const config = {
  apiConfig: {
    // API_ENDPOINT_URL: "http://127.0.0.1:5001/fullproof-app/us-central1/api",
    API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL ?? "https://us-central1-fullproof-app.cloudfunctions.net/api",
  },

  // environment: "staging" | "production"
  environment: {
    production: {
      collectionPath: "",
    },
    staging: {
      collectionPath: process.env.REACT_APP_COLLECTION_PATH ?? "_DEVELOPMENT/stageapi/",
    },
  },
  //
  categories: [
    // CATEGORY
    {
      categoryName: "edibles",
      title: "Edibles",
      filterType: ["categories"],
      type: "category",
      image: "/images/category/edibles.png",
      category: "Edibles",
      subcategories: ["Gummies", "Chocolate", "Bar", "Cookie", "Baked"],
      categoryList: true,
    },
    {
      categoryName: "beverages",
      title: "Beverages",
      filterType: ["categories"],
      type: "category",
      image: "/images/category/beverages.png",
      category: "Beverages",
      subcategories: ["0% ABV", "Wine", "Beer", "Spritzer", "Mocktail", "Energy"],
      categoryList: true,
    },
    {
      categoryName: "enhancers",
      title: "Enhancers",
      filterType: ["categories"],
      type: "category",
      image: "/images/category/enhancers.png",
      category: "Enhancers",
      subcategories: ["Patch", "Capsule", "Tincture", "Topical", "Balm", "Lotion"],
      categoryList: true,
    },
    {
      categoryName: "flower",
      title: "Flower",
      filterType: ["categories"],
      type: "category",
      image: "/images/filter/flower.png",
      category: "Flower",
      subcategories: ["Infused", "Terped", "Shake"],
      categoryList: true,
    },
    {
      categoryName: "prerolls",
      title: "Prerolls",
      filterType: ["categories"],
      type: "category",
      image: "/images/filter/Preroll.png",
      category: "Prerolls",
      subcategories: ["Infused", "Donut", "Blunt", "Joints", "Minis"],
      categoryList: true,
    },
    {
      categoryName: "vape",
      title: "Vape",
      filterType: ["categories"],
      type: "category",
      image: "/images/filter/Vape.png",
      category: "Vape",
      subcategories: ["Carts", "AIO", "Pods", "Batteries"],
      categoryList: true,
    },
    {
      categoryName: "concentrate",
      title: "Concentrate",
      filterType: ["categories"],
      type: "category",
      image: "/images/category/concentrate.png",
      category: "Concentrate",
      subcategories: ["Rosin", "Live resin", "Sauce", "Crystalline", "Budder", "Shatter"],
      categoryList: false,
    },
    // SUBCATEGORY CATEGORY

    {
      categoryName: "sub-edibles",
      title: "Edibles",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/category/edibles.png",
      subcategories: ["Gummies", "Chocolate", "Bar", "Cookie", "Baked"],
      categoryList: true,
    },
    {
      categoryName: "sub-beverages",
      title: "Beverages",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/category/beverages.png",
      subcategories: ["0% ABV", "Wine", "Beer", "Spritzer", "Mocktail", "Energy"],
      categoryList: true,
    },
    {
      categoryName: "sub-enhancers",
      title: "Enhancers",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/category/enhancers.png",
      subcategories: ["Patch", "Capsule", "Tincture", "Topical", "Balm", "Lotion"],
      categoryList: true,
    },
    {
      categoryName: "sub-flower",
      title: "Flower",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/filter/flower.png",
      subcategories: ["Infused", "Terped", "Shake"],
      categoryList: true,
    },
    {
      categoryName: "sub-prerolls",
      title: "Prerolls",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/filter/Preroll.png",
      subcategories: ["Infused", "Donut", "Blunt", "Joints", "Minis"],
      categoryList: true,
    },
    {
      categoryName: "sub-vape",
      title: "Vape",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/filter/Vape.png",
      subcategories: ["Carts", "AIO", "Pods", "Batteries"],
      categoryList: true,
    },
    {
      categoryName: "sub-concentrate",
      title: "Concentrate",
      filterType: ["subcategories"],
      type: "category",
      image: "/images/category/concentrate.png",
      subcategories: ["Rosin", "Live resin", "Sauce", "Crystalline", "Budder", "Shatter"],
      categoryList: false,
    },
    // CUSTOM CATEGORIES
    {
      categoryName: "popular-products",
      title: "Popular Products",
      filterType: ["popular_product"],
      type: "custom-category",
      image: "/images/category/concentrate.png",
      categoryList: false,
    },
    {
      categoryName: "staff-picks",
      title: "Staff Picks For You",
      filterType: ["staff_pick"],
      type: "custom-category",
      image: "/images/category/concentrate.png",
      categoryList: false,
    },

    // VIBES CATEGORY
    { categoryName: "sleep", title: "Sleep", filterType: ["vibes"], type: "vibe", image: "/images/vibes/sleep.png", vibes: ["Sleep"], vibeList: true },
    {
      categoryName: "relieve-pain",
      title: "Relieve Pain",
      filterType: ["vibes"],
      type: "vibe",
      image: "/images/vibes/pain.png",
      vibes: ["Relieve Pain"],
      vibeList: true,
    },
    { categoryName: "elevate", title: "Elevate", filterType: ["vibes"], type: "vibe", image: "/images/vibes/elevate.png", vibes: ["Elevate"], vibeList: true },
    { categoryName: "relax", title: "Relax", filterType: ["vibes"], type: "vibe", image: "/images/vibes/relax.png", vibes: ["Relax"], vibeList: true },
    {
      categoryName: "connect",
      title: "Connect",
      filterType: ["vibes"],
      type: "vibe",
      image: "/images/vibes/connect.png",
      vibes: ["Connect"],
      vibeList: true,
    },
    { categoryName: "create", title: "Create", filterType: ["vibes"], type: "vibe", image: "/images/vibes/create.png", vibes: ["Create"], vibeList: true },
    {
      categoryName: "focus-energize",
      time: "Focus",
      filterType: ["vibes"],
      type: "vibe",
      image: "/images/vibes/focus.png",
      vibes: ["Focus & Energize"],
      vibeList: true,
    },

    // TAGS CATEGORY
    { categoryName: "THC", title: "THC", filterType: ["tags"], type: "tag", image: "", tags: ["THC"] },
    { categoryName: "CBD", title: "CBD", filterType: ["tags"], type: "tag", image: "", tags: ["CBD"] },
    { categoryName: "Kava", title: "Kava", filterType: ["tags"], type: "tag", image: "", tags: ["Kava"] },
    { categoryName: "Myco", title: "Myco", filterType: ["tags"], type: "tag", image: "", tags: ["Myco"] },
    { categoryName: "Kratom", title: "Kratom", filterType: ["tags"], type: "tag", image: "", tags: ["Kratom"] },
    { categoryName: "Mushroom", title: "Mushroom", filterType: ["tags"], type: "tag", image: "", tags: ["Mushroom"] },
  ],
  types: ["Plant", "Magic"],
  strain_types: ["Indica", "Sativa", "Hybrid", "I-Hybrid", "S-Hybrid", "Other"],
};

export const categories = config.categories;
export const strain_types = config.strain_types;
export default config;
